import { faChevronLeft, faChevronRight, faCircleChevronLeft, faCircleChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import BlazeSlider from 'blaze-slider'
import 'blaze-slider/dist/blaze.css'
import { useEffect, useRef } from 'react'

function useBlazeSlider(config, onSlide) {
    const sliderRef = useRef(null)
    const elRef = useRef(null)
  
    useEffect(() => {

      if (!sliderRef.current) {
        sliderRef.current = new BlazeSlider(elRef.current, config)
        
        if(onSlide) {
          sliderRef.current.onSlide((pageIndex) => {
            onSlide(pageIndex)
          })
        }
        
      }

    }, [])
  
    return elRef
  }

export function Slider({config,onSlide, navBtnClass, disableNavBtn, disablePagination, children}) {
    const sliderRef = useBlazeSlider(config || {
        all: {
            enableAutoplay: true,
            autoplayInterval: 3000,
            transitionDuration: 1000,
            slidesToShow: 3,
        },
      }, onSlide)
    return <>
        <div ref={sliderRef} className="blaze-slider mx-auto w-full">
            <div className="blaze-container">
                <div className="blaze-track-container">
                  <div className="blaze-track">
                      {children}
                  </div>
                </div>
                {
                  disableNavBtn!==true && <>
                    <button className={`${navBtnClass} blaze-prev absolute top-[50%] left-2`}><FontAwesomeIcon icon={faChevronLeft} className='h-4 w-4 sm:h-7 sm:w-7'/></button>
                    <button className={`${navBtnClass} blaze-next absolute top-[50%] right-2`}><FontAwesomeIcon icon={faChevronRight} className='h-4 w-4 sm:h-7 sm:w-7'/></button>
                  </>
                }
                
                {
                  disablePagination!==true && <>
                  <div className="blaze-pagination"></div>
                  </>
                }
                
            </div>
        </div>
    </>
}